import React from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { useLanguage } from '../../shared/contexts/LanguageContext';

interface LanguageSwitcherProps {
  mobile?: boolean;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ mobile = false }) => {
  const { language, setLanguage, t } = useLanguage();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (newLanguage: 'en' | 'de') => {
    setLanguage(newLanguage);
    handleClose();
  };

  // Mobile version with simple buttons
  if (mobile) {
    return (
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
        <Button
          onClick={() => setLanguage('en')}
          variant={language === 'en' ? 'contained' : 'outlined'}
          size="small"
          sx={{
            minWidth: '32px',
            textTransform: 'none',
            fontSize: '0.75rem',
            px: 0.5,
            py: 0.5,
            height: '28px',
          }}
        >
          EN
        </Button>
        <Button
          onClick={() => setLanguage('de')}
          variant={language === 'de' ? 'contained' : 'outlined'}
          size="small"
          sx={{
            minWidth: '32px',
            textTransform: 'none',
            fontSize: '0.75rem',
            px: 0.5,
            py: 0.5,
            height: '28px',
          }}
        >
          DE
        </Button>
      </Box>
    );
  }

  // Desktop version with dropdown menu
  return (
    <Box>
      <Button
        onClick={handleClick}
        startIcon={<LanguageIcon />}
        sx={{
          color: 'inherit',
          textTransform: 'none',
          minWidth: 'auto',
          px: 1,
        }}
      >
        <Typography variant="body2">
          {language === 'en' ? 'EN' : 'DE'}
        </Typography>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => handleLanguageChange('en')}
          selected={language === 'en'}
        >
          {t('language.en')}
        </MenuItem>
        <MenuItem
          onClick={() => handleLanguageChange('de')}
          selected={language === 'de'}
        >
          {t('language.de')}
        </MenuItem>
      </Menu>
    </Box>
  );
};
